import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, map } from 'rxjs';
import { OverlayFile, FormFile, PacksFile } from '../models/sut-models';


@Injectable({ providedIn: 'root' })
export class OverlayService {
constructor(private http: HttpClient) {}


loadPacks(): Observable<PacksFile> {
return this.http.get<PacksFile>('assets/sut/pack.json');
}


loadOverlay(drugKey: string): Observable<OverlayFile> {
return this.http.get<OverlayFile>(`assets/sut/overlays/${drugKey}.overlay.json`);
}


loadForm(formId: string): Observable<FormFile> {
return this.http.get<FormFile>(`assets/sut/forms/${formId}.form.json`);
}


loadAllForDrug(drugKey: string): Observable<{ packs: PacksFile; overlay: OverlayFile; form: FormFile }>{
return forkJoin({
packs: this.loadPacks(),
overlay: this.loadOverlay(drugKey)
}).pipe(
map(({ packs, overlay }) => ({ packs, overlay })),
// load the first indication's form (all indications map to same form in this example)
// You can switch form per indication later at runtime.
// Here we default to overlay.indications[0].form_id for initial render.
// The UI lets user change indication and reloads form if needed.
// To keep demo simple, all indications use the same form id: "pembro_main".
// We'll fetch it in the component.
) as any;
}
}